export default () => ({
    results: [],
    loading: true,
    page: 1,
    pagesMax: 0,
    canLoadMore: false,

    processResults(response) {
        let ref = this;
        $.each(response.data.results, function (k, v) {
            ref.results.push({
                'id': v.id,
                'title': v.title,
                'permalink': v.permalink,
                'excerpt': v.excerpt,
                'image': v.image,
                'video_enabled': v.video_enabled !== null && v.video_enabled === true,
                'video_url': v.video_url,
                'video_poster': v.video_poster
            });
        });

        this.loading = false;
        this.page++;
        this.pagesMax = response.data.max_num_pages;
        this.canLoadMore = (this.pagesMax >= this.page);
    },

    loadCategory(categoryId) {
        this.loading = true;
        this.page = 1;
        this.results = [];

        $.post(london_theme_ajax_endpoint, {
            'action': 'london_post_retrieve_projects',
            'term_id': categoryId
        }).then((response) => {
            this.processResults(response);
        });
    },

    loadMore() {
        this.loading = true;

        $.post(london_theme_ajax_endpoint, {
            'action': 'london_post_retrieve_projects',
            'page': this.page
        }).then((response) => {
            this.processResults(response);
        });
    }
});
